module.exports = __webpack_public_path__ + "img/남성.fcd2e13.png";